import { useTranslation } from 'react-i18next';
import { Box, IconButton, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  audioBoxStyles,
  audioControlButtonStyles,
  audioDeleteButtonStyles,
  progressBarContainerStyles,
  progressBarStyles,
  progressHandleStyles,
  timeDisplayStyles,
} from './styles';

interface AudioPlayerProps {
  isPlaying: boolean;
  currentPlayTime: number;
  progress: number;
  formatTime: (seconds: number) => string;
  onPlay: () => void;
  onPause: () => void;
  onDelete: () => void;
}

export const AudioPlayer = ({
  isPlaying,
  currentPlayTime,
  progress,
  formatTime,
  onPlay,
  onPause,
  onDelete,
}: AudioPlayerProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={audioBoxStyles}>
      <IconButton
        aria-label={
          isPlaying ? t('callsMenu.selectedStage.audioPlayer.pause') : t('callsMenu.selectedStage.audioPlayer.play')
        }
        sx={audioControlButtonStyles}
        onClick={isPlaying ? onPause : onPlay}
      >
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>

      <Box sx={progressBarContainerStyles}>
        <Box sx={progressBarStyles(progress)} />
        <Box sx={progressHandleStyles(progress)} />
      </Box>

      <Box sx={timeDisplayStyles}>
        <Typography variant="body2" color="text.primary">
          {formatTime(currentPlayTime)}
        </Typography>
      </Box>

      <IconButton aria-label="eliminar" sx={audioDeleteButtonStyles} onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
    </Box>
  );
};
